import { trpc } from "../trpc";

function useAdminApprovalRule({ enabled = true }: { enabled?: boolean }) {
  const { data, isLoading } = trpc.approval.adminApprovalsRule.useQuery(
    undefined,
    {
      enabled,
    },
  );

  return {
    canAdminApprove: Boolean(data?.adminApprovalRules?.config?.adminEnabled),
    isLoading,
  };
}

export default useAdminApprovalRule;
